/* eslint-disable react/style-prop-object */
import React, { useState, useEffect } from 'react';
import {
   Row, Col, Empty, Spin
} from 'antd';
import axios from 'axios';
import Utils from '../../../misc/Utils';
import {
   Chart as ChartJS,
   CategoryScale,
   LinearScale,
   BarElement,
   Title,
   Tooltip,
   Legend,
} from 'chart.js';
import { IntroSum } from '../components';
import DiagnosticReportUtils from '../../../misc/DiagnosticReportUtils';
import app from 'reactjs-pdf-reader';

export function MTKLanguageSummaryReport(props) {
   const [reportData, setReportData] = useState(null);
   const [dataLoading, setDataLoading] = useState(false);

   const [knowing, setKnowing] = useState(null);
   const [exploring, setExploring] = useState(null);
   const [appreciating, setAppreciating] = useState(null);
   const [caring, setCaring] = useState(null);
   const [total, setTotal] = useState(null);

   const [pcData, setPCData] = useState(null);
   // const [VN, setVN] = useState(null);

   var aid = props.assessment_id !== undefined ? props.assessment_id : props.assignment_id;

   useEffect(() => {
      Utils.verifyJwt();

      ChartJS.register(
         CategoryScale,
         LinearScale,
         BarElement,
         Title,
         Tooltip,
         Legend
      );

      getReport(aid, props.section_id);
   }, [aid]);

   const getReport = (assignment_id, section_id) => {
      setDataLoading(true);

      var url = "";

      if (props.version === 1)
         url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/getdiagnosticreportdata?aid=${assignment_id}&sid=${section_id}`;
      else
         url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/v2/getdiagnosticreportdata?aid=${assignment_id}&sids=${section_id}&s=${props.subject_id}&sy=${props.school_year}`;

      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;

            var preData = data.filter(item => item.diagnostic_type === 'pre');
            var postData = data.filter(item => item.diagnostic_type === 'post');
            // setVN(preData.length);

            if (props.version === 1)
               url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/getdiagnosticsummarypercentdata?aid=${assignment_id}&sid=${section_id}`;
            else
               url = `${process.env.REACT_APP_API_BRAINEE_DIAGNOSTIC}/v2/getdiagnosticsummarypercentdata?aid=${assignment_id}&sids=${section_id}&s=${props.subject_id}&sy=${props.school_year}`;

            axios.get(url).then((response) => {

               if (response.data) {
                  const data2 = response.data;

                  setPCData(data2[0]);
                  extractData(preData, postData);

                  setReportData(data);
                  setDataLoading(false);
               }
            }, (error) => {
               console.log(error.message);
            });
         }
      }, (error) => {
         console.log(error.message);
      });
      // }
   }

   // Configuration for subject-specific data extraction
   const subjectConfigurations = {
      mtsci: {
         categories: {
            knowing: { fields: Array.from({ length: 7 }, (_, i) => `s${i + 1}`), mean: 6.3, stdDev: 1.22, ranges: [[0, 5.68, 'Beginner'], [5.69, 6.91, 'Basic'], [6.92, 7, 'Competent']] },
            exploring: { fields: Array.from({ length: 6 }, (_, i) => `s${i + 8}`), mean: 5.37, stdDev: 0.8, ranges: [[0, 4.96, 'Beginner'], [4.97, 5.77, 'Basic'], [5.78, 6, 'Competent']] },
            appreciating: { fields: Array.from({ length: 4 }, (_, i) => `s${i + 14}`), mean: 2.92, stdDev: 1.02, ranges: [[0, 2.4, 'Beginner'], [2.41, 3.43, 'Basic'], [3.44, 14, 'Competent']] },
            caring: { fields: Array.from({ length: 3 }, (_, i) => `s${i + 18}`), mean: 2, stdDev: 0.92, ranges: [[0, 1.53, 'Beginner'], [1.54, 2.46, 'Basic'], [2.47, 18, 'Competent']] },
         },
         totalRanges: [[0, 15.3, 'Beginner'], [15.31, 18.17, 'Basic'], [18.18, 20, 'Competent']],
         setters: { total: setTotal, knowing: setKnowing, exploring: setExploring, appreciating: setAppreciating, caring: setCaring },
      },
   };

   // Subject-specific wrappers for convenience
   const extractData = (pre_data, post_data) => Utils.extractDataForDiagnosticSummaryReport(props.diagnostic_type, pre_data, post_data, subjectConfigurations['mtsci']);

   return (
      <>
         {
            dataLoading
               ?
               <div className='center-empty-space'>
                  <Spin size='large' tip="Loading data, please wait..." />
               </div>
               :
               (reportData !== null && reportData.length > 0)
                  ?
                  <div className="dashboard-item-inner3" style={{ margin: '20px' }}>
                     <div style={{ fontFamily: 'calibri' }} id='summary-report'>
                        <div>

                           <IntroSum
                              grade_level={props.template}
                              section={props.section_desc}
                              school_name={reportData[0].school_name}
                              subject_id={props.subject_id}
                              subject={props.subject}
                              backgroundColor="#4F81BD"
                              diagnostic_date={reportData[0].diagnostic_date}
                              diagnostic_type={props.diagnostic_type}
                           />

                           <p style={{ marginTop: '10pt', marginBottom: '0pt', lineHeight: '115%', fontSize: '12pt' }}>
                              <strong>&nbsp;</strong>
                           </p>
                           <div style={{ pageBreakBefore: 'always' }}></div>
                           <p style={{ textAlign: 'center', fontSize: '14pt' }}><strong>Summary of Results for {props.subject}</strong></p>
                           <p style={{ textAlign: 'center' }}><strong>{reportData[0].diagnostic_type === 'post' ? 'POST TEST' : 'PRE TEST'}</strong></p>
                           <p style={{ marginTop: '0pt', marginBottom: '0pt' }}><strong>MEAN LEVEL OF SCORES IN THE SUBJECT AREAS</strong></p>
                           <table style={{ width: '100%', border: '0.75pt solid #cccccc', borderCollapse: 'collapse' }}>
                              <tbody>
                                 <tr>
                                    <td style={{ textAlign: 'center', width: '25%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Area</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '4%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>N</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Pretest Mean</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Post Test Mean</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Min</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '11%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Max</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '14%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Standard Deviation</span></strong>
                                    </td>
                                    <td style={{ textAlign: 'center', width: '13%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <strong><span style={{ color: '#ffffff' }}>Proficiency Level</span></strong>
                                    </td>
                                 </tr>
                                 {DiagnosticReportUtils.generateMeanLevelRow('Knowing who we are and our families', knowing, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Exploring my Community', exploring, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Appreciating our Country', appreciating, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('Caring for the World', caring, false)}
                                 {DiagnosticReportUtils.generateMeanLevelRow('TOTAL', total, true)}
                              </tbody>
                           </table>
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>&nbsp;</strong></p>
                           <table style={{ width: '100%', border: '0.75pt solid #cccccc', borderCollapse: 'collapse' }}>
                              <tbody>
                                 <tr style={{ height: '14.5pt' }}>
                                    <td style={{ width: '39.3%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Content Standards</span></strong></p>
                                    </td>
                                    <td colSpan={3} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Beginner</span></strong></p>
                                    </td>
                                    <td colSpan={3} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Basic</span></strong></p>
                                    </td>
                                    <td colSpan={3} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center', marginBottom: '0pt' }}><strong><span style={{ color: '#ffffff' }}>Competent</span></strong></p>
                                    </td>
                                 </tr>
                                 {DiagnosticReportUtils.generateContentStandards('Knowing who we are and our families', 0, 5.68, 5.69, 6.91, 6.92, 7)}
                                 {DiagnosticReportUtils.generateContentStandards('Exploring my Community', 0, 4.96, 4.97, 5.77, 5.78, 6)}
                                 {DiagnosticReportUtils.generateContentStandards('Appreciating our Country', 0, 2.4, 2.41, 3.43, 3.44, 4)}
                                 {DiagnosticReportUtils.generateContentStandards('Caring for the World', 0, 1.53, 1.54, 2.46, 2.47, 23)}
                                 {DiagnosticReportUtils.generateContentStandards('TOTAL', 0, 15.3, 15.31, 18.17, 18.18, 20)}
                              </tbody>
                           </table>
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>&nbsp;</strong></p>
                           {DiagnosticReportUtils.generateMTFrequencyRow('Knowing who we are and our families', knowing, 1)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Exploring my Community', exploring, 2)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Appreciating our Country', appreciating, 3)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('Caring for the World', caring, 4)}
                           {DiagnosticReportUtils.generateMTFrequencyRow('TOTAL', total, 5)}
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>&nbsp;</strong></p>
                           <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>Percent of Correct</strong></p>
                           <table style={{ width: '100%', border: '0.75pt solid #cccccc', borderCollapse: 'collapse' }}>
                              <tbody>
                                 <tr>
                                    <td colSpan={2} style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center' }}><strong><span style={{ color: '#ffffff' }}>LEARNING COMPETENCY</span></strong></p>
                                    </td>
                                    <td style={{ width: '19.9%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center' }}><strong><span style={{ color: '#ffffff' }}>Pre Test Percent Correct for the Level</span></strong></p>
                                    </td>
                                    <td style={{ width: '20.6%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                                       <p style={{ textAlign: 'center' }}><strong><span style={{ color: '#ffffff' }}>Post Test Percent Correct for the Level</span></strong></p>
                                    </td>
                                 </tr>

                                 <tr>
                                    <td colSpan={4} style={{ width: '11.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                                       <p style={{ margin: '0pt 5.65pt', textAlign: 'left', fontSize: '11pt' }}>
                                          <strong>Part 1: Knowing who we are and our families</strong>
                                       </p>
                                    </td>
                                 </tr>

                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Identify one’s given name, friends' names, their family members, and common things they use that are found at home;", pcData.pre_s1, pcData.post_s1, 1)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Produce the sound of the letter it stands for", pcData.pre_s2, pcData.post_s2, 2)}
                                 <div style={{ pageBreakBefore: 'always' }}></div>
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Produce the sound of the letter it stands for", pcData.pre_s3, pcData.post_s3, 3)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Write the letters of the alphabet in uppercase and lowercase form", pcData.pre_s4, pcData.post_s4, 4)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Write the letters of the alphabet in uppercase and lowercase form", pcData.pre_s5, pcData.post_s5, 5)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Narrate one’s personal experiences", pcData.pre_s6, pcData.post_s6, 6)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Use polite greetings and courteous expressions in appropriate situations", pcData.pre_s7, pcData.post_s7, 7)}

                                 <tr>
                                    <td colSpan={4} style={{ width: '11.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                                       <p style={{ margin: '0pt 5.65pt', textAlign: 'left', fontSize: '11pt' }}>
                                          <strong>Part 2: Exploring my community</strong>
                                       </p>
                                    </td>
                                 </tr>

                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Recognize that sounding off letters form words", pcData.pre_s8, pcData.post_s8, 8)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Recognize that sounding off letters form words", pcData.pre_s1, pcData.post_s1, 1)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Identify familiar sounds in the environment", pcData.pre_s10, pcData.post_s10, 10)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Describe the different places and persons belonging in one’s community", pcData.pre_s11, pcData.post_s11, 11)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Give the correct sequence of events in a local text listened to;", pcData.pre_s12, pcData.post_s12, 12)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Tell the names of the days in a week and months in a year", pcData.pre_s13, pcData.post_s13, 13)}

                                 <tr>
                                    <td colSpan={4} style={{ width: '11.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                                       <p style={{ margin: '0pt 5.65pt', textAlign: 'left', fontSize: '11pt' }}>
                                          <strong>Part 3: Appreciating our Country</strong>
                                       </p>
                                    </td>
                                 </tr>

                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Participate in dialogues or conversations about familiar events", pcData.pre_s14, pcData.post_s14, 14)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Identify solutions to a problem based on a local text listened to", pcData.pre_s15, pcData.post_s15, 15)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Identify solutions to a problem based on a local text listened to", pcData.pre_s16, pcData.post_s16, 16)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Identify solutions to a problem based on a local text listened to", pcData.pre_s17, pcData.post_s17, 17)}

                                 <tr>
                                    <td colSpan={4} style={{ width: '11.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                                       <p style={{ margin: '0pt 5.65pt', textAlign: 'left', fontSize: '11pt' }}>
                                          <strong>Part 4: Caring for the World</strong>
                                       </p>
                                    </td>
                                 </tr>

                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Predict outcomes based on any given situation", pcData.pre_s18, pcData.post_s18, 18)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Predict outcomes based on any given situation", pcData.pre_s19, pcData.post_s19, 19)}
                                 {DiagnosticReportUtils.generateMTPercentCorrectRow("Predict outcomes based on any given situation", pcData.pre_s20, pcData.post_s20, 20)}
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div >
                  :
                  <div className='center-empty-space'>
                     <Empty
                        description='No Data Found'
                        image="../images/brainee_mascot.png"
                     />
                  </div>
         }

      </>
   );
}